import { useEffect } from "react";
import { FilterTab } from "../../../components/Filters";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../store/state/SwitchTabs";
import { DataTabs } from "./Data";
import { setViewMode } from "../../../store/state/ViewMode";

interface SecondaryHeaderProps {
  showViewMode?: boolean;
  ExchangeDataTabs?: { label: string }[];
}

const SecondaryHeader = ({
  showViewMode = true,
  ExchangeDataTabs,
}: SecondaryHeaderProps) => {
  const dispatch = useDispatch();
  const activeViewMode = useSelector((state: any) => state.viewMode.activeView);
  const tabNames = useSelector((state: any) => state.switchTabs.tabNames);
  const showTabs = useSelector((state: any) => state.switchTabs.showTabs);
  const selectedTab = useSelector((state: any) => state.switchTabs.activeTab);

  const handleTabChange = (option: string) => {
if (option === "Sub Station with OA") return;
if (option === "Sub Station with OA Trend Analysis") return;
if (option === "Restricted demand") return;
if (option === "Restricted demand Trend Analysis") return;
    dispatch(setActiveTab(option));
    const url = new URL(window.location.href);
    url.searchParams.set("tab", option);
    window.history.pushState({}, "", url);
  };

  useEffect(() => {
    // Update selected tab if URL changes
    const handlePopState = () => {
      const tab = new URLSearchParams(window.location.search).get("tab");
      if (tab && tabNames.includes(tab)) {
        dispatch(setActiveTab(tab));
      }
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [dispatch, tabNames]);

  useEffect(() => {
    if (ExchangeDataTabs && ExchangeDataTabs.length > 0) {
      const initialTab = ExchangeDataTabs[0];
      dispatch(setViewMode(initialTab));
    } else {
      dispatch(setViewMode(DataTabs[0]));
    }
  }, [ExchangeDataTabs, dispatch]);

  return (
    <div className="bg-white p-[0.5rem] rounded-xl flex flex-wrap gap-3 justify-between items-center">
      <>
        <div>
          {showViewMode && (
            <div>
              {ExchangeDataTabs && ExchangeDataTabs.length > 0 ? (
                <FilterTab
                  options={ExchangeDataTabs.map((item) => item.label)}
                  selected={[activeViewMode.label]}
                  onClick={(option, index) => {
                    dispatch(setViewMode(ExchangeDataTabs[index]));
                  }}
                />
              ) : (
                <FilterTab
                  options={DataTabs.map((item) => item.label)}
                  selected={[activeViewMode.label]}
                  onClick={(option, index) => {
                    dispatch(setViewMode(DataTabs[index]));
                  }}
                />
              )}
            </div>
          )}
        </div>

              {showTabs ? (
                    tabNames.length === 1 ? (
                      <div className="tab tab-active rounded-lg	">{tabNames[0]}</div>
                    ) : (
                      <FilterTab
                        options={tabNames}
                        selected={[selectedTab]}
                        onClick={handleTabChange}
                      />
                    )
                  ) : (
                    <div className="w-40"></div>
                  )}
      </>
    </div>
  );
};

export default SecondaryHeader;
